export function useOnClick(props) {
  return function onClick(event) {
    if (
      event.target?.id === 'modal-backdrop' &&
      typeof props?.onClose === 'function' &&
      props?.closeOnClickOutside
    ) {
      props.onClose()
    }
  }
}
